module.exports = __webpack_public_path__ + "img/todo.6d7c6fa5.png";